<template>
  <div class="pl_table-view--headline pl_copy100">
    <slot></slot>
  </div>
</template>
